module.exports = __webpack_public_path__ + "assets/4c2bad310212ace6167e15c4ac52cc04.png";